import 'animate.css';

import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import { useIsLogged } from '../../../hooks/session/useIsLogged';
import eventsPanel, { PageViewPages } from '../../../services/events';
import { Form } from './Form';
import { LoginEmailNotValidated } from './LoginEmailNotValidated';
import { UserAuthContextProvider } from './context';

export const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [notValidatedEmail, setNotValidatedEmail] = useState<string | undefined>(undefined);

  const { isLogged } = useIsLogged();

  useEffect(() => {
    if (isLogged) {
      const redirectTo = searchParams.get(`redirectTo`);
      if ((redirectTo ?? ``) !== ``) {
        // TODO: Control if URL is from highway??
        navigate(redirectTo as string);
      } else {
        navigate(routes.PRIVATE_HIGHWAY);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  useEffect(() => {
    if (!isLoaded) {
      eventsPanel.pageView(PageViewPages.login);
      setIsLoaded(true);
    }
  }, [isLoaded]);

  if (notValidatedEmail) {
    return <LoginEmailNotValidated email={notValidatedEmail} setNotValidatedEmail={setNotValidatedEmail} />;
  }

  return (
    <UserAuthContextProvider>
      <Form setNotValidatedEmail={setNotValidatedEmail} />
    </UserAuthContextProvider>
  );
};
